import { PropsWithChildren } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Paper,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import SafetyBox from "../../../common/SafetyBox";

const PaymentCardDivider = () => <Box my={3} borderTop="1px dashed #003B4A" />;

export const PaymentCardTextPaper = ({ children }: PropsWithChildren<{}>) => (
  <Paper component={Box} py={2} px={3}>
    {children}
  </Paper>
);

export const PaymentCardTextBox = ({ htmlText }: { htmlText: string }) => (
  <Box
    sx={{ wordBreak: "break-word", width: "100%" }}
    dangerouslySetInnerHTML={{
      __html: htmlText,
    }}
  />
);

type PaymentCardProps = PropsWithChildren<{
  selected: boolean;
  value: "online" | "offline";
  topLabel: string;
  selectedText: string;
  notSelectedText: string;
  priceLabel: string;
  price: string;
  buttonText: string;
  onPay: () => void;
}>;

const PaymentCard = ({
  selected,
  value,
  topLabel,
  selectedText,
  notSelectedText,
  priceLabel,
  price,
  buttonText,
  children,
  onPay,
}: PaymentCardProps) => (
  <Paper
    mt={4}
    p={2}
    component={Box}
    variant={selected ? "elevation" : "outlined"}
    className={selected ? "green" : "lightGrey"}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <FormControlLabel value={value} control={<Radio />} label={topLabel} />
      <Typography fontSize="12px" color="#898A8D">
        {selected ? selectedText : notSelectedText}
      </Typography>
    </Stack>

    {selected && (
      <>
        <PaymentCardDivider />
        {children}
        <PaymentCardDivider />

        <Stack direction="row" mb={3} justifyContent="space-between">
          <Typography fontWeight="700" color="#54565A">
            {priceLabel}:
          </Typography>
          <Typography fontSize="20px" fontWeight="700">
            {price}
          </Typography>
        </Stack>

        <Stack justifyContent="center" alignItems="center" gap={2}>
          <Button
            variant="contained"
            sx={{ minWidth: "206px" }}
            onClick={onPay}
          >
            {buttonText}
          </Button>
          <SafetyBox />
        </Stack>
      </>
    )}
  </Paper>
);

export default PaymentCard;
